import EducationMaterialItem from './EducationMaterialItem';
import AutocompleteV2 from '../AutocompleteV2/AutocompleteV2';
import apiClient from '../../Services/NetteApiClient';
import { useState } from 'react';

export default function EducationMaterialAutocomplete(props) {
	const [items, setItems] = useState([]);

	const handleSearch = async value => {
		const { data } = await apiClient.get(
			`/education-material/search/fulltext?autocomplete_query=${value}`,
		);

		setItems(data);
	};

	const handleChange = value => {
		props.onChange?.(value);
	};

	return (
		<AutocompleteV2
			inputPlaceholder={props.placeholder || 'Vyberte edukační materiály...'}
			items={items}
			onSearch={handleSearch}
			onChange={handleChange}
			itemTemplate={props => (
				<EducationMaterialItem {...props} user={props.item} />
			)}
		/>
	);
}
